import React from "react";
import { string } from "prop-types";
import { OverlayTrigger, Popover } from "@icg360/ui-toolkit";
import { Icon } from "@icg360/design-system";
import { decodeXml } from "../../shared/xmlUtils";
import styles from "./Edit.styles";
var stylesOverride =
/*#__PURE__*/
// In order to target precisely the style we want, we have to write some CSS
// targetting the innards of `.popover-content`
React.createElement("style", {
  dangerouslySetInnerHTML: {
    __html: "\n      .popover-content {\n        max-height: 180px;\n        overflow: scroll;\n      }\n      .popover-content::after {\n        content: \"\";\n        position: absolute;\n        height: 10px;\n        background-image: linear-gradient( rgba(255,255,255,0), #fff );\n        width: 100%;\n        bottom: 0;\n        left: 0;\n      }\n    "
  }
});
HelpIcon.propTypes = {
  help: string.isRequired // string which may contain XML

};
export default function HelpIcon(_ref) {
  var help = _ref.help;
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    overlay: /*#__PURE__*/React.createElement(Popover, {
      id: "tooltip"
    }, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: decodeXml(help)
      }
    })),
    placement: "right",
    rootClose: true,
    trigger: "click"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
    style: styles.helpIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Question",
    size: "sm"
  })), stylesOverride));
}